import React from 'react';
import { Link } from 'react-router-dom';
import SmallCarousel from './SmallCarousel';
import { ThumbnailProductImage } from 'scy/ProductImage';
import { url as productUrl } from 'shared/models/product';
import styles from './styles.mod.scss';

const ThumbnailLinkCarousel = ({ products, loading, sliderSettings }) => (
  <SmallCarousel {...sliderSettings}>
    {products.map(product => (
      <Link
        key={product.sku_id}
        to={productUrl(product)}
        className={styles.productImageContainer}
        style={loading ? { pointerEvents: 'none' } : {}}
      >
        <ThumbnailProductImage
          product={product}
          loading={loading}
          className={styles.productImage}
        />
      </Link>
    ))}
  </SmallCarousel>
);

export default ThumbnailLinkCarousel;
